import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { carData } from "../../../../utils/constants/carData";
import BidHistorySection from "../BidHistory";
import CarDetails from "@common/pages/Dashboard/components/CarDetails";
import { mainContainer } from "../VehicleInfoSidebarSx";
import theme from "../../../../theme";
import SaleInformation from "../SaleInformation";

const TimeLeftInAuction = () => {
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.secondary,
        textAlign: "center",
        borderRadius: "0.75rem", // 12px
        padding: "1rem 0.5rem",
      }}
    >
      <Typography fontWeight={600} fontSize="1.1rem"
        sx={{
          color: theme.palette.text.secondary
        }}
      >
        Time Left In Auction
      </Typography>
      <Typography fontWeight={500} fontSize="1rem" marginTop="0.25rem">
        <span style={{ fontWeight: 700, color: theme.palette.text.secondary }}>12</span>{" "} hours{" "}
        <span style={{ fontWeight: 500, color: theme.palette.text.secondary }}>20</span>{" "} mins{" "}
        <span style={{ fontWeight: 600, color: theme.palette.text.secondary }}>26</span>{" "} sec
      </Typography>
    </Box>
  );
};

// Main Car Detail Page component
const WatchListDetail = () => {
  return (
    <Grid
      container
      spacing={4}
      sx={mainContainer}
    >
      {/* Left sidebar with buttons */}
      <Grid size={{ xs: 12, lg: 3 }}>
        <Box display={"flex"} flexDirection="column" gap={2}>
          <TimeLeftInAuction />

          <BidHistorySection bids={carData.bidHistory} />

          <SaleInformation />
        </Box>
      </Grid>
      <CarDetails />
      {/* Main content area */}
    </Grid>
  );
};

export default WatchListDetail;
